export default __webpack_public_path__ + "static/media/nflStaff8.76855fad.jpg";